const shouldLog = import.meta.env.DEV || import.meta.env.VITE_DEBUG_LOGS === 'true';

type ConsoleMethod = (...args: unknown[]) => void;

const createLogger = (method: ConsoleMethod) =>
  (...args: unknown[]) => {
    if (!shouldLog) return;
    method.call(console, ...args);
  };

export const debugLog = createLogger(console.log);
export const debugWarn = createLogger(console.warn);
export const debugError = createLogger(console.error);
